module.exports = __webpack_public_path__ + "img/bg_part1.fb7e5b87.png";